import { combineReducers } from '@reduxjs/toolkit';
import { hydrateReducer } from '@doda/common/src/redux/utils/hydrateReducer';
import {
  memberInfoInitialState,
  memberInfoReducer,
} from '@doda/common/src/redux/features/memberInfo';
import {
  queryParamsInitialState,
  queryParamsReducer,
} from '@doda/common/src/redux/features/queryParams';
import {
  analyticsInitialState,
  analyticsReducer,
} from '@doda/common/src/redux/features/analytics';
import {
  canonicalInitialState,
  canonicalReducer,
} from '@doda/common/src/redux/features/canonical';
import {
  abTestInitialState,
  abTestReducer,
} from '@doda/common/src/redux/features/abTest';
import {
  resourceUrlInitialState,
  resourceUrlReducer,
} from 'redux/features/resourceUrl';
import { bookmarkInitialState, bookmarkReducer } from './slices/bookmark';
import {
  jobSearchDetailInitialState,
  jobSearchDetailReducer,
} from './features/jobSearchDetail';

const reducer = combineReducers({
  memberInfo: memberInfoReducer,
  queryParams: queryParamsReducer,
  analytics: analyticsReducer,
  canonical: canonicalReducer,
  bookmark: bookmarkReducer,
  jobSearchDetail: jobSearchDetailReducer,
  abTest: abTestReducer,
  resourceUrl: resourceUrlReducer,
});

const initialState: ReturnType<typeof reducer> = {
  memberInfo: memberInfoInitialState,
  queryParams: queryParamsInitialState,
  analytics: analyticsInitialState,
  canonical: canonicalInitialState,
  bookmark: bookmarkInitialState,
  jobSearchDetail: jobSearchDetailInitialState,
  abTest: abTestInitialState,
  resourceUrl: resourceUrlInitialState,
};

export const rootReducer = hydrateReducer(reducer, initialState);
